import * as React from "react";

import { IconProps } from "./types";

const TicketIcon = ({
  width = 21,
  height = 17,
  className,
  style,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    className={className}
    style={style}
    viewBox="-2 -4 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.333 2.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7.17a3 3 0 0 1 5.66 0h1.17a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1h-1.17a3.001 3.001 0 0 1-5.66 0h-7.17Zm-3 1a3 3 0 0 1 3-3h8a1 1 0 0 1 1 1 1 1 0 1 0 2 0 1 1 0 0 1 1-1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2a1 1 0 0 1-1-1 1 1 0 0 0-2 0 1 1 0 0 1-1 1h-8a3 3 0 0 1-3-3v-10Zm13 2a1 1 0 0 1 1 1V7a1 1 0 0 1-2 0v-.5a1 1 0 0 1 1-1Zm1 4.5a1 1 0 0 0-2 0v.5a1 1 0 1 0 2 0V10Z"
      stroke="inherit"
      fill="inherit"
      strokeWidth="0"
    />
  </svg>
);

export default TicketIcon;
